import { render } from "./GoTop.vue?vue&type=template&id=17521820&scoped=true"
import script from "./GoTop.vue?vue&type=script&lang=js"
export * from "./GoTop.vue?vue&type=script&lang=js"

import "./GoTop.vue?vue&type=style&index=0&id=17521820&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-17521820"]])

export default __exports__